export const ARCANA = [
    { name: 'Death', icon: '☠️', faIcon: 'skull', color: 'bg-gray-900 text-white rounded-full' },
    { name: 'Fate', icon: '🎲', faIcon: 'dice', color: 'bg-purple-400 text-white' },
    { name: 'Forces', icon: '⚡', faIcon: 'bolt', color: 'bg-red-400 text-white' },
    { name: 'Life', icon: '🌿', faIcon: 'leaf', color: 'bg-green-400 text-white' },
    { name: 'Matter', icon: '🧱', faIcon: 'cube', color: 'bg-stone-400 text-white' },
    { name: 'Mind', icon: '🧠', faIcon: 'brain', color: 'bg-blue-500 text-white' },
    { name: 'Prime', icon: '✨', faIcon: 'star', color: 'bg-yellow-200 text-black' },
    { name: 'Space', icon: '🔮', faIcon: 'compass', color: 'bg-indigo-600 text-white' },
    { name: 'Spirit', icon: '👻', faIcon: 'ghost', color: 'bg-indigo-400 text-black' },
    { name: 'Time', icon: '⏳', faIcon: 'hourglass-half', color: 'bg-teal-500 text-white' }
  ];
  
  // Map tier names to numeric spell levels
  export const TIER_MAPPING = {
    'Initiate': 1,
    'Apprentice': 2,
    'Disciple': 3,
    'Adept': 4, 
    'Master': 5
  };